import { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  TextField,
  TableHead,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
  Grid,
  Tooltip,
  Typography,
  Alert,
  Backdrop,
  CircularProgress,
} from '@mui/material';

import SubCard from 'src/components/cards/SubCard';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import axios from 'src/utils/axios';
import RevenueCard from 'src/components/cards/RevenueCard';
import AccountBalanceWalletTwoToneIcon from '@mui/icons-material/AccountBalanceWalletTwoTone';
import MonetizationOnTwoToneIcon from '@mui/icons-material/MonetizationOnTwoTone';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PrintIcon from '@mui/icons-material/Print';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Select, MenuItem } from '@material-ui/core';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import { makeStyles } from '@material-ui/styles';

import { getUser } from 'src/utils/Common';
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


// ==============================|| PROFILE 1 - SETTINGS ||============================== //

const Expense = ({ EmployeeNr, ServiceShopId }) => {
  const theme = useTheme();


  if (EmployeeNr === 0) {
    return <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
          <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
          </Typography>
        </Alert>     </Grid>
    </Grid>
  };




  const [employeeExpenseData, setEmployeeExpenseData] = useState([]);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [editableExpenseId, setEditableExpenseId] = useState(0);
  const classes = useStyles();
  const [yetki, setYetki] = useState([]);
  const [Ocakvalue, setOcakValue] = useState(0);
  const [Subatvalue, setSubatValue] = useState(0);
  const [Martvalue, setMartValue] = useState(0);
  const [Nisanvalue, setNisanValue] = useState(0);
  const [Mayisvalue, setMayisValue] = useState(0);
  const [Haziranvalue, setHaziranValue] = useState(0);
  const [Temmuzvalue, setTemmuzValue] = useState(0);
  const [Agustosvalue, setAgustosValue] = useState(0);
  const [Eylulvalue, setEylulValue] = useState(0);
  const [Ekimvalue, setEkimValue] = useState(0);
  const [Kasimvalue, setKasimValue] = useState(0);
  const [Aralikvalue, setAralikValue] = useState(0);
  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    getEmployeeExpenseData();
    getEmployeeYetki();
  }, [selectedYear]);

  const getEmployeeExpenseData = () => {
    setLoading(true);
    var headers = {
      'Content-Type': 'application/json',
    };
    axios.get(`/GetEmployeeExpense/1/${selectedYear}/${EmployeeNr}`, headers).then((response) => {
      setEmployeeExpenseData(response.data);
      setLoading(false);
    });
  };

  const Tarihler = () => {
    const years = Array.from({ length: 5 }, (_, index) => currentYear - index);


    const handleChange = (event) => {
      setSelectedYear(event.target.value);
    };
    return (
      <Select
        value={selectedYear}
        onChange={handleChange}
        IconComponent={() => <CalendarMonthIcon />}>
        {years.map((year) => (
          <MenuItem key={year} value={year}>
            {year} &nbsp;
          </MenuItem>
        ))}
      </Select>
    );
  };


  const getEmployeeYetki = () => {
    setLoading(true);
    axios.get(`GetEmployeeYetki`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setYetki(response.data);
        } else {
          setYetki([]);
        }
        setLoading(false);
      });

  }
  const setExpenseDataToState = (row) => {
    setOcakValue(row.Ocak);
    setSubatValue(row.Subat);
    setMartValue(row.Mart);
    setNisanValue(row.Nisan);
    setMayisValue(row.Mayis);
    setHaziranValue(row.Haziran);
    setTemmuzValue(row.Temmuz);
    setAgustosValue(row.Agustos);
    setEylulValue(row.Eylul);
    setEkimValue(row.Ekim);
    setKasimValue(row.Kasim);
    setAralikValue(row.Aralik);
  };

  const handleEditButtonClick = (row) => {
    setExpenseDataToState(row);
    setEditableExpenseId(row.ExpenseId);
  };

  const handleCancelButtonClick = () => {
    setEditableExpenseId(0);
  };

  const handleSaveButtonClick = () => {

    var headers = {
      'Content-Type': 'application/json',
    };

    //loop for 12 months and create an array of objects
    var data = [];
    for (var i = 1; i <= 12; i++) {
      data.push({
        ExpenseId: editableExpenseId,
        EmployeeId: EmployeeNr,
        ServiceShopId: 1,
        UserId: "",
        ExpenseYear: selectedYear,
        MonthId: i,
        RoleId: SessionUser?.ManagementRoleId,
        ExpenseAmount: i == 1 ? Ocakvalue :
          i == 2 ? Subatvalue :
            i == 3 ? Martvalue :
              i == 4 ? Nisanvalue :
                i == 5 ? Mayisvalue :
                  i == 6 ? Haziranvalue :
                    i == 7 ? Temmuzvalue :
                      i == 8 ? Agustosvalue :
                        i == 9 ? Eylulvalue :
                          i == 10 ? Ekimvalue :
                            i == 11 ? Kasimvalue : Aralikvalue,
      });
    }

    axios.post('/SetEmployeeExpense', data, headers).then((response) => {
      if (response.data.ErrorCode == 0) {
        //success message
      }
      setEditableExpenseId(0);
      getEmployeeExpenseData()
    });
  };
  const calculateTotalExpense = (ExpenseId) => {
    var total = 0;
    employeeExpenseData.map((row) => {
      if (row.ExpenseId === ExpenseId) {
        total =
          row.Ocak +
          row.Subat +
          row.Mart +
          row.Nisan +
          row.Mayis +
          row.Haziran +
          row.Temmuz +
          row.Agustos +
          row.Eylul +
          row.Ekim +
          row.Kasim +
          row.Aralik;
      }
    });
    return total;
  }
  return (
    <SubCard title="Giderler">
      {
        loading ?
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <Grid container spacing={2}>
        <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
          <Grid item xs={12} sm={6}>
          </Grid>
          <Grid item xs={12} sm={6} spacing={2} sx={{ textAlign: 'right' }}>
            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker views={['year']} size="small"/>
            </LocalizationProvider> */}
            <Tarihler />
            <Tooltip title="Filtre">
              <IconButton size="large" onClick={getEmployeeExpenseData}>
                <FilterAltIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Aktar">
              <IconButton size="large">
                <PrintIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Sorgula">
              <IconButton size="large">
                <FilterListIcon />
              </IconButton>
            </Tooltip>

          </Grid>
        </Grid>
        <Grid item xs={12}>
          <TableContainer >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '200px !important' }} >Gider Kalemleri</TableCell>
                  <TableCell align="center" >Ocak</TableCell>
                  <TableCell align="center" >Şubat</TableCell>
                  <TableCell align="center" >Mart</TableCell>
                  <TableCell align="center" >Nisan</TableCell>
                  <TableCell align="center" >Mayıs</TableCell>
                  <TableCell align="center" >Haziran</TableCell>
                  <TableCell align="center" >Temmuz</TableCell>
                  <TableCell align="center" >Ağustos</TableCell>
                  <TableCell align="center" >Eylül</TableCell>
                  <TableCell align="center" >Ekim</TableCell>
                  <TableCell align='center' >Kasım</TableCell>
                  <TableCell align="center" >Aralık</TableCell>
                  <TableCell align="center" >Aksiyon</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {employeeExpenseData.map((row) => (
                  <TableRow key={row.ExpenseId}>
                    <TableCell component="th" scope="row">
                      {row.ExpenseDesc}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Ocakvalue}
                          onChange={(e) => setOcakValue(e.target.value)}
                        /> : row.Ocak}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Subatvalue}
                          onChange={(e) => setSubatValue(e.target.value)}
                        /> : row.Subat}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Martvalue}
                          onChange={(e) => setMartValue(e.target.value)}
                        /> : row.Mart}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Nisanvalue}
                          onChange={(e) => setNisanValue(e.target.value)}
                        /> : row.Nisan}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Mayisvalue}
                          onChange={(e) => setMayisValue(e.target.value)}
                        /> : row.Mayis}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Haziranvalue}
                          onChange={(e) => setHaziranValue(e.target.value)}
                        /> : row.Haziran}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Temmuzvalue}
                          onChange={(e) => setTemmuzValue(e.target.value)}
                        /> : row.Temmuz}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Agustosvalue}
                          onChange={(e) => setAgustosValue(e.target.value)}
                        /> : row.Agustos}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Eylulvalue}
                          onChange={(e) => setEylulValue(e.target.value)}
                        /> : row.Eylul}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Ekimvalue}
                          onChange={(e) => setEkimValue(e.target.value)}
                        /> : row.Ekim}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Kasimvalue}
                          onChange={(e) => setKasimValue(e.target.value)}
                        /> : row.Kasim}
                    </TableCell>
                    <TableCell align="center" >
                      {row.ExpenseId == editableExpenseId ?
                        <TextField
                          variant="outlined"
                          type="tel"
                          size="small"
                          className={classes.textField}
                          value={Aralikvalue}
                          onChange={(e) => setAralikValue(e.target.value)}
                        /> : row.Aralik}
                    </TableCell>
                    <TableCell align="center">
                      {row.ExpenseId == editableExpenseId ?
                        <div style={{ width: '100px' }}>
                          <Tooltip title="Kaydet">
                            <IconButton size="large" onClick={() => handleSaveButtonClick()}
                             disabled={yetki.find(item => item.ALAN_ADI === 'dsExpenseSave')?.DISABLE_ALAN}
                            >
                              <SaveIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="İptal">
                            <IconButton size="large" onClick={() => handleCancelButtonClick()}
                             disabled={yetki.find(item => item.ALAN_ADI === 'dsExpenseCancel')?.DISABLE_ALAN}>
                              <CancelIcon />
                            </IconButton>
                          </Tooltip>
                        </div> :
                        <Tooltip title="Düzenle">
                          <IconButton size="large" onClick={() => handleEditButtonClick(row)}
                          disabled={yetki.find(item => item.ALAN_ADI === 'dsExpenseEdit')?.DISABLE_ALAN}>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid item lg={4} display={{ xs: "none", sm: "none", lg: "block" }}>
        </Grid>
        <Grid item xs={12} lg={4} sm={6} >
          <SubCard>
            <RevenueCard
              primary="Toplam Brüt Ücret"
              secondary={calculateTotalExpense(42) + " ₺"}
              content="Çalışan Yıllık Toplam Brüt Ücret"
              iconPrimary={MonetizationOnTwoToneIcon}
              color={theme.palette.secondary.light}
            />
          </SubCard>
        </Grid>
        <Grid item xs={12} lg={4} sm={6}>
          <SubCard>
            <RevenueCard
              primary="Toplam Ek Ödeme "
              secondary={calculateTotalExpense(46) + " ₺"}
              content="Fazla Mesai + Prim + Elden Ödeme"
              iconPrimary={AccountBalanceWalletTwoToneIcon}
              color={theme.palette.secondary.light}
            />
          </SubCard>
        </Grid>
      </Grid>
    </SubCard >
  );
};

export default Expense;
